import useSocketReconnect from '../../utils/useSocketReconnect';
import LlistaEvents from './LlistaEvents'
import styles from './Events.styles';
import { useState } from 'react';
import ChooseCastell from './proves/ChooseCastell';
import { useEffect } from 'react';
import { NoSignal } from '../Interface';
import UserInfo from '../login/UserInfo';
import OnlyOneEvent from './OnlyOneEvent';
import { fetchAPI } from '../../utils/utils';
import { etiquetaUsersFromMapping } from '../../utils/etiquetaUsers';
import HeaderTabs from './HeaderTabs';
import useModelFolders from './proves/useModelFolders';
import { can } from '../../utils/permissions';
import OnboardingWizard, { shouldShowOnboarding, shouldShowMiniPopup, OnboardingMiniPopup, resetOnboardingSkipped } from '../onboarding/OnboardingWizard';

export const formatDurations = data => {
    let dict = {}
    const canvis = data.split('\n')

    for (const canvi of canvis) {
        if (canvi.split('=').length !== 2) continue
        const [prova, duration] = canvi.split('=')
        dict[prova] = parseInt(duration)
    }

    return dict;
}

function ProvesApp(props) {
    useSocketReconnect(props.socket, () => {
        props.socket.emit('.request_durations');
    });

    const { socket, isInEventToEdit, isModels, castellersInfo, setCastellersInfo } = props;

    const params = window.location.pathname.split('/').filter(part => part != '');
    const eventToEdit = params[0] === 'event' ? parseInt(params[1]) : null

    const [selectedEvent, setSelectedEvent] = useState(-1);
    const [importPopupClosed, setImportPopupClosed] = useState(true);

    const [eventType, setEventType] = useState('esdeveniments')
    const [durations, setDurations] = useState({})

    const [bundlesInfo, setBundlesInfo] = useState([]);

    const [etiquetes, setEtiquetes] = useState([]);
    const [etiquetaUsers, setEtiquetaUsers] = useState({});

    const [events, setEvents] = useState(null);

    const [onboardingStatus, setOnboardingStatus] = useState(null);
    const [showOnboarding, setShowOnboarding] = useState(false);

    const modelFolders = useModelFolders({ enabled: isModels && can(props.userInfo, 'ACCESS_MODELS'), socket, userInfo: props.userInfo });

    const exports = {
        modelFolders,
        'setSelectedEvent': setSelectedEvent,
        'setImportPopupClosed': setImportPopupClosed,
        'durations': durations,
        'setDurations': setDurations,
        'castellersInfo': castellersInfo,
        'bundlesInfo': bundlesInfo,
        'etiquetes': etiquetes,
        'etiquetaUsers': etiquetaUsers,
        ...props
    };

    const refreshOnboardingStatus = () => {
        fetchAPI('/onboarding_status', (status) => {
            setOnboardingStatus(status);
            setShowOnboarding(shouldShowOnboarding(status));
        });
    };

    useEffect(() => {
        refreshOnboardingStatus();
    }, []);

    useEffect(() => {
        fetchAPI('/calendar', data => {
            setEvents(data.calendar_events.events);
        })
    }, []);

    useEffect(() => {
        fetchAPI('/bundles', data => setBundlesInfo(Array.isArray(data) ? data : []))
    }, [])

    useEffect(() => {
        fetchAPI('/etiquetes', setEtiquetes)
    }, [])

    useEffect(() => {
        if (etiquetes.length === 0) return;
        // One request and one render for all etiquetes (it was one per etiqueta, 40 on sarri)
        fetchAPI('/all_user_etiquetes', mapping => setEtiquetaUsers(etiquetaUsersFromMapping(etiquetes, mapping)))
    }, [
        etiquetes
    ])

    useEffect(() => {
        socket.emit('.request_durations');

        const onDurations = data => setDurations(formatDurations(data))
        socket.on('.durations', onDurations)

        const onDurationsChanged = (prova, duration) => {            
            setDurations(prev => ({...prev, [prova]: duration}))
            socket.emit('.request_durations');
        }
        socket.on('.durations_changed', onDurationsChanged)

        return () => {
            socket.off('.durations', onDurations)
            socket.off('.durations_changed', onDurationsChanged)
        }
    }, [])

    if (showOnboarding) {
        return (
            <OnboardingWizard
                socket={socket}
                onComplete={() => setShowOnboarding(false)}
                onboardingStatus={onboardingStatus}
                refreshStatus={refreshOnboardingStatus}
                userInfo={props.userInfo}
            />
        );
    }

    return (
        <div style={{ width: '90%' }}>
            <NoSignal socket={socket} />

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <UserInfo castellersInfo={castellersInfo} {...props} />
            </div>

            <HeaderTabs {...exports} />

            <div id="llista-container" style={{...((eventToEdit || isModels) ? {} : styles.llistes_container)}}>
                <ChooseCastell event={selectedEvent} closed={importPopupClosed} setClosed={setImportPopupClosed} {...exports}  />

                {
                    eventToEdit || isModels ? <>
                        <OnlyOneEvent
                            eventToEdit={eventToEdit}
                            isModels={isModels}
                            {...exports}
                        />
                    </> : <>
                        {/* <LlistaEvents type='esdeveniments' current={true} {...exports} /> */}

                        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                            <div style={{...{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }, ...{ flex: 1, margin: 2, padding: 10, textAlign: 'center', backgroundColor: eventType === 'esdeveniments'  ? '#333' : '#ddd', color: eventType === 'esdeveniments' ? 'white' : '#333' }}} onClick={() => eventType === 'esdeveniments' ? setEventType('esdeveniments') : setEventType('esdeveniments')}>Totes</div>
                            <div style={{...{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }, ...{ flex: 1, margin: 2, padding: 10, textAlign: 'center', backgroundColor: eventType === 'actuació'  ? '#333' : '#ddd', color: eventType === 'actuació' ? 'white' : '#333' }}} onClick={() => eventType === 'actuació' ? setEventType('esdeveniments') : setEventType('actuació')}>Actuacions</div>
                            <div style={{...{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }, ...{ flex: 1, margin: 2, padding: 10, textAlign: 'center', backgroundColor: eventType === 'assaig'    ? '#333' : '#ddd', color: eventType === 'assaig' ? 'white' : '#333' }}} onClick={() => eventType === 'assaig' ? setEventType('esdeveniments') : setEventType('assaig')}>Assaigs</div>
                            <div style={{...{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }, ...{ flex: 1, margin: 2, padding: 10, textAlign: 'center', backgroundColor: eventType === 'activitat' ? '#333' : '#ddd', color: eventType === 'activitat' ? 'white' : '#333' }}} onClick={() => eventType === 'activitat' ? setEventType('esdeveniments') : setEventType('activitat')}>Activitats</div>
                        </div>

                        <LlistaEvents
                            type={eventType}
                            events={events}
                            setEvents={setEvents}
                            {...exports}
                        />
                    </>
                }
            </div>

            <div style={{ margin: 20 }}>&nbsp;</div>

            {shouldShowMiniPopup(onboardingStatus) ? (
                <OnboardingMiniPopup 
                    onboardingStatus={onboardingStatus}
                    onOpenWizard={() => {
                        resetOnboardingSkipped();
                        setShowOnboarding(true);
                    }}
                />
            ) : null}
        </div>
    );
}

export default ProvesApp;